import { Fragment as _Fragment, jsx as _jsx } from "@emotion/react/jsx-runtime";
import { memo } from 'react';
const ConditionalRender = memo(({ isContentVisible, children, fallback }) => {
    if (isContentVisible) {
        return _jsx(_Fragment, { children: children });
    }
    if (fallback) {
        return _jsx(_Fragment, { children: fallback });
    }
    return null;
});
export default ConditionalRender;
//# sourceMappingURL=index.js.map